// extracted by mini-css-extract-plugin
module.exports = {"dashboardContainer":"AdGroupsDashboard_dashboardContainer__3UjVQ","dashboardControls":"AdGroupsDashboard_dashboardControls__1pQR7"};